import { Injectable, Inject } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';
import { AuthState, OktaAuth } from '@okta/okta-auth-js';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  isAuthenticated: boolean = false;
  username?: string;

  constructor(
    private router: Router,
    public _oktaStateService: OktaAuthStateService,
    @Inject(OKTA_AUTH) private _oktaAuth: OktaAuth
  ) {}

  /**
   * Determines whether the route can be activated based on the user's authentication status.
   * @returns A promise that resolves to true if the user is authenticated, otherwise false.
   */
  async canActivate(): Promise<boolean> {
    const isAuthenticated = await this._oktaAuth.isAuthenticated();
    // var isAuthorized: boolean | undefined;
    // if (isAuthorized == undefined) this.router.navigate(['unauthorized']);

    // if (isAuthorized) {
    //   const userClaims = await this._oktaAuth.getUser();
    //   this.username = userClaims['lastName'] + ', ' + userClaims['firstName'];
    //   return true;
    // } else {
    //   this.router.navigate(['unauthorized']);
    //   return false;
    // }
    return isAuthenticated;
  }
}
